import React from 'react';
import { Button } from '@mui/material';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';

export default function NotAuthorized({ message }) {
  const history = useHistory();
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 place-content-center min-h-screen">
      <div></div>
      <div className="p-6 bg-white rounded-md">
        <div className=" text-center">
          ขออภัย คุณไม่มีสิทธิในการเข้าถึงหน้าดังกล่าว
        </div>
        <div className="text-red-600 text-center">{message}</div>
        <div className="flex justify-center mt-2 gap-2">
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              history.push('/');
            }}
          >
            กลับสู่หน้าหลัก
          </Button>
        </div>
      </div>
      <div></div>
    </div>
  );
}

NotAuthorized.propTypes = {
  message: PropTypes.string,
};

NotAuthorized.defaultProps = {
  message: '',
};
